import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import Player from '../Player/Player';
import PlayerContextProvider from '../Player/context/playerContext';
import {getFavorite} from '../../store/actions/userListActions';
import CatalogTrackList from '../catalog/CatalogTrackList';
import {scrollBar} from '../../styles/sc-mixins';
import FilterContextProvider from '../catalog/context/filterContext';
import {setPage} from '../../store/reducers/userSlice';
import Loader from '../../components/Loader';
import CatalogContextProvider from '../catalog/context/catalogContext';
import {getPaymentProfile} from '../../store/actions/userActions';
import {getSubscribe} from '../../store/actions/subscribeActions';

const StyledContainer = styled.div`
  padding: 30px 0.9375rem 110px;
  height:  ${({height}) => height - 200}px;
  overflow-y: auto;
  ${scrollBar()};
);
`;

const Favorite = () => {
	const dispatch = useDispatch();
	const {favorite, isUserListLoading} = useSelector((state) => state.userList);
	const {downloadType, downloadTrackId, error} = useSelector((state) => state.subscribe);

	useEffect(() => {
		dispatch(getFavorite());
		dispatch(getPaymentProfile());
		dispatch(getSubscribe());
	}, [dispatch]);

	useEffect(() => {
		dispatch(setPage('favorite'));
	}, [dispatch]);

	useEffect(() => {
		if (!error && downloadType) {
			const URL = `${window.location.origin}/download/?track_id=${downloadTrackId}&type=${downloadType}`;
			const downloadFile = new Promise(() => {
				saveAs(URL, `${downloadTrackId}.${downloadType}`);
			});
			downloadFile.then(() => {
				dispatch(clearType());
			});
		}
		if (error) {
			const promise = new Promise(() => {
				notification.error({
					message: error,
				});
			});
			promise.then(() => {
				dispatch(clearError());
			});
		}
	}, [dispatch, downloadType, error, downloadTrackId]);

	return (
		<CatalogContextProvider>
			<FilterContextProvider>
				<PlayerContextProvider>
					<StyledContainer>
						<div className="cart__list-header mb-3" style={{fontSize: 18}}>
							{
								!!favorite.length
									? <div>Избранные треки: {favorite.length}</div>
									: <div>Список избранных треков пуст</div>
							}
						</div>
						{
							isUserListLoading && !favorite.length
							&& <div className="h-100 w-100 d-flex align-items-center justify-content-center">
								<Loader/>
							</div>
						}
						{
							!!favorite.length
							&& <CatalogTrackList tracks={favorite} isLoading={isUserListLoading}/>
						}
					</StyledContainer>
					<Player/>
				</PlayerContextProvider>
			</FilterContextProvider>
		</CatalogContextProvider>
	);
};

export default Favorite;
